module.exports = __webpack_public_path__ + "c98b60b1a5ef39356c6365cfc6cfbd1c.pdf";